import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import moment from 'moment';

import { usePages } from '../hooks/usePages';

import { TablePaginationActions } from '../helpers/TablePaginationActions';

import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';

import { BuscarAudienciaProgramada } from '../connections/audiencias/AgendaConnection';

import { AudienciaProgramadaProps } from '../interfaces/audiencias/AgendaInterface';

interface Props {
    open:               boolean;
    idExpediente:       number;
    setOpen:            Dispatch<SetStateAction<boolean>>;
    obtenerAgenda:      ( params: AudienciaProgramadaProps ) => void;
}

export const DialogBuscarAudiencia = ({ open, setOpen, idExpediente, obtenerAgenda }: Props) => {

    const [rows, setRows] = useState<AudienciaProgramadaProps[]>( [] );
    
    const [loadingSearch, setLoadingSearch] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(5);

    const handleSeleccionar = ( row: AudienciaProgramadaProps ) => {

        obtenerAgenda( row );
        setOpen( false );

    }

    useEffect(() => {

        async function Obtener() {

            setRows( [] );
            setLoadingSearch( true );           

            await BuscarAudienciaProgramada( idExpediente ?? 0 ).then( resp => {

                setTimeout(() => {

                    setRows( resp );
                    setLoadingSearch( false );

                }, 700);


            });

        }

        if ( open && idExpediente !== 0 ) {
            Obtener();
        }

    }, [ open, idExpediente ]);

    return (
        <>
            <Dialog 
                fullWidth
                open={open} 
                maxWidth='md' 
            >

                <DialogTitle>Audiencias agendadas</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ md: 12, xs: 12 }} >

                            <TableContainer sx={{ borderRadius: 3 }} component={Paper}>
                                                    
                                <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Tipo de audiencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Juez(a)</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Secretario(a) de audiencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%' }}> </TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (
                                                rowsPerPage > 0
                                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : rows
                                            ).map( ( row ) => {

                                                const { id, tipoAudiencia, fechaInicio, fechaFin, sala, juez, secretario } = row;

                                                return <TableRow key={ id }>

                                                    <TableCell>
                                                  
                                                        <Typography variant='subtitle2' fontWeight={'bold'}>
                                                            { tipoAudiencia }                                                     
                                                        </Typography> 
                                                      
                                                        <Typography variant='subtitle2' color='secondary' mt={1}>
                                                            { sala }                                                    
                                                        </Typography>                                   
                                                    
                                                        <Typography variant='subtitle2' color='secondary' mt={1}>

                                                            { 
                                                                fechaInicio 
                                                                &&
                                                                    <>
                                                                        <span>{ moment(fechaInicio).format('DD-MM-YYYY') }</span>

                                                                        <span style={{ margin: '0 2px' }}> </span>

                                                                        <span>{ moment(fechaInicio).format('HH:mm') }</span>

                                                                        <span style={{ margin: '0 2px' }}>-</span>
                                                                        
                                                                        <span>{ fechaFin ? moment(fechaFin).format('HH:mm') : '' }</span>
                                                                    </>
                                                            }

                                                        </Typography>                                            
                                                    
                                                    </TableCell>

                                                    <TableCell> { juez } </TableCell>

                                                    <TableCell> { secretario } </TableCell>
                                                    
                                                    <TableCell>

                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            onClick={ () => handleSeleccionar( row ) }
                                                        >
                                                            Seleccionar
                                                        </Button>

                                                    </TableCell>

                                                </TableRow>

                                            })
                                        }

                                        {
                                            rows.length === 0 &&
                                            (
                                                <TableRow>

                                                    <TableCell
                                                        colSpan={9}
                                                        align="center"
                                                    >

                                                        <Typography variant="caption" color='secondary'>
                                                            {
                                                                loadingSearch
                                                                ?
                                                                    'Buscando ....'
                                                                :
                                                                    'No se encontraron resultados'
                                                            }
                                                        </Typography>

                                                    </TableCell>

                                                </TableRow>
                                            )
                                        }


                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>

                                            <TablePagination
                                                rowsPerPageOptions={[]}
                                                colSpan={4}
                                                count={rows.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                ActionsComponent={TablePaginationActions}

                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                        return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' onClick={ () => setOpen( false ) }>Cancelar</Button>
                </DialogActions>

            </Dialog>
        </>
    )
}
